import * as defaultImport from "@splunk/visualizations/FillerGauge";
export * from "@splunk/visualizations/FillerGauge";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
